import { useMemo } from "react";
import { useTranslation } from "react-i18next";
import { localizeProduct } from "../utils/mapWooProduct";
import { useCategoryLookup } from "./useCategoryLookup";

export function useLocalizedProduct(product) {
  const { i18n } = useTranslation();
  const categoryById = useCategoryLookup();

  return useMemo(
    () => localizeProduct(product, i18n.language, categoryById),
    [product, i18n.language, categoryById],
  );
}

export function useLocalizedProducts(products = []) {
  const { i18n } = useTranslation();
  const categoryById = useCategoryLookup();

  return useMemo(
    () => products.map((product) => localizeProduct(product, i18n.language, categoryById)),
    [products, i18n.language, categoryById],
  );
}
